import { useEffect, useState } from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  theme: suppliedTheme,
  ...props
}) => {
  const { theme = "system" } = useTheme()
  const [borrowerTheme, setBorrowerTheme] = useState(() =>
    document.body.dataset.borrowerTheme || null
  )

  useEffect(() => {
    const update = () => setBorrowerTheme(document.body.dataset.borrowerTheme || null)
    const observer = new MutationObserver(update)
    observer.observe(document.body, { attributes: true, attributeFilter: ["data-borrower-theme"] })
    update()
    return () => observer.disconnect()
  }, [])

  return (
    <Sonner
      theme={borrowerTheme || suppliedTheme || theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
